// 园区仓储接口
export default {
  ENABLE: '/financial/receivableSettlementExpense/importExcel', // 园区仓储费用清单导入
};
